<div class="container-fluid glb-popup">
  <h2>{{ formTitle }}</h2>
  <p-toast [style]="{ marginTop: '80px' }"> </p-toast>
  <p-confirmDialog
    header="Confirmation"
    icon="pi pi-exclamation-triangle"
  ></p-confirmDialog>
  <span style="float: right; top: -50px; background-color: transparent"><app-help-link [helpName]="'msgCampaign'" [formReadOnly]="true"></app-help-link></span>
  <button
    mat-icon-button
    [mat-dialog-close]="true"
    style="float: right; top: -50px; background-color: transparent"
    >
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr />
  <div [formGroup]="form1" class="forms w-100 d-block">
    <div class="row m-0">
      <div class="col-lg-12">
        @if (formAlert) {
          <div class="w-100 mb-3">
            <div
              class="w-100"
            style="
              text-align: center;
              background-color: yellow;
              padding: 5px;
              margin-bottom: 15px;
            "
              >
              <p>
                <b>{{ formAlert }}</b>
              </p>
            </div>
          </div>
        }
      </div>

      <div class="col-lg-12">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="name" id="name" type="text" pInputText/>
          <label for="name">Template Name</label>

          @for (validation of validationMessages.name; track validation) {
            <span>
              @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="tempEmailName" id="tempEmailName" type="text" pInputText/>
          <label for="tempEmailName">Template Email Mapping Name</label>

          @for (validation of validationMessages.tempEmailName; track validation) {
            <span>
              @if (form1.get('tempEmailName').hasError(validation.type) && (form1.get('tempEmailName').dirty || form1.get('tempEmailName').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="statuses" formControlName="status" optionLabel="name" optionValue="value"
          placeholder="status"></p-dropdown>
          <label for="status">Status/Type</label>
          @for (validation of validationMessages.status; track validation) {
            <span>
              @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-lg-12">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="communicationMediums" formControlName="communicationMediumCode" optionLabel="name" optionValue="value"
          placeholder="Communication Medium"></p-dropdown>
          <label for="communicationMediumCode">Communication Medium</label>
          @for (validation of validationMessages.communicationMediumCode; track validation) {
            <span>
              @if (form1.get('communicationMediumCode').hasError(validation.type) && (form1.get('communicationMediumCode').dirty || form1.get('communicationMediumCode').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-lg-12">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="msgAudiences" formControlName="msgAudience" optionLabel="name" optionValue="value"
          placeholder="msgAudience"></p-dropdown>
          <label for="msgAudience">msgAudience/Type</label>
          @for (validation of validationMessages.msgAudience; track validation) {
            <span>
              @if (form1.get('msgAudience').hasError(validation.type) && (form1.get('msgAudience').dirty || form1.get('msgAudience').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="senderName" id="senderName" type="text" pInputText/>
          <label for="senderName">Sender Name</label>

          @for (validation of validationMessages.name; track validation) {
            <span>
              @if (form1.get('senderName').hasError(validation.type) && (form1.get('senderName').dirty || form1.get('senderName').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="senderEmail" id="senderEmail" type="email" pInputText/>
          <label for="senderEmail">Sender Email</label>
          @for (validation of validationMessages.senderEmail; track validation) {
            <span>
              @if (form1.get('senderEmail').hasError(validation.type) && (form1.get('senderEmail').dirty || form1.get('senderEmail').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="properties" formControlName="shortTermRentalId" optionLabel="propertyCode"
            optionValue="shortTermRentalId" [filter]="true" filterBy="propertyCode" [showClear]="false"
            placeholder="Select Property">
          </p-dropdown>
          <label for="Select Property">Select Property</label>
          @for (validation of validationMessages.shortTermRentalId; track validation) {
            <span>
              @if (form1.get('shortTermRentalId').hasError(validation.type) && (form1.get('shortTermRentalId').dirty || form1.get('shortTermRentalId').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="developments" formControlName="developmentId" optionLabel="addressDevelopmentName"
            optionValue="developmentId" [filter]="true" filterBy="addressDevelopmentName" [showClear]="false"
            placeholder="Select Development">
          </p-dropdown>
          <label for="Select Development">Select Development</label>
          @for (validation of validationMessages.developmentId; track validation) {
            <span>
              @if (form1.get('developmentId').hasError(validation.type) && (form1.get('developmentId').dirty || form1.get('developmentId').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="locationIds" formControlName="locationId" optionLabel="name"
            optionValue="locationId"
            placeholder="Select Location">
          </p-dropdown>
          <label for="Select Development">Select Location</label>
          @for (validation of validationMessages.locationId; track validation) {
            <span>
              @if (form1.get('locationId').hasError(validation.type) && (form1.get('locationId').dirty || form1.get('locationId').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="buildingNames" formControlName="adrBuildingName" optionLabel="adrBuildingName"
            optionValue="adrBuildingName" [filter]="true" filterBy="adrBuildingName" [showClear]="false"
            placeholder="Select Building">
          </p-dropdown>
          <label for="Select Building">Select Building</label>
          @for (validation of validationMessages.adrBuildingName; track validation) {
            <span>
              @if (form1.get('adrBuildingName').hasError(validation.type) && (form1.get('adrBuildingName').dirty || form1.get('adrBuildingName').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="districts" formControlName="adrDistrict" optionLabel="adrDistrict"
            optionValue="adrDistrict" [filter]="true" filterBy="adrDistrict" [showClear]="false"
            placeholder="Select District">
          </p-dropdown>
          <label for="Select District">Select District</label>
          @for (validation of validationMessages.adrDistrict; track validation) {
            <span>
              @if (form1.get('adrDistrict').hasError(validation.type) && (form1.get('adrDistrict').dirty || form1.get('adrDistrict').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="states" formControlName="adrState" optionLabel="adrState"
            optionValue="adrState" [filter]="true" filterBy="adrState" [showClear]="false"
            placeholder="Select State">
          </p-dropdown>
          <label for="Select State">Select State</label>
          @for (validation of validationMessages.adrState; track validation) {
            <span>
              @if (form1.get('adrState').hasError(validation.type) && (form1.get('adrState').dirty || form1.get('adrState').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="regions" formControlName="adrRegion" optionLabel="adrRegion"
            optionValue="adrRegion" [filter]="true" filterBy="adrRegion" [showClear]="false"
            placeholder="Select Region">
          </p-dropdown>
          <label for="Select Region">Select Region</label>
          @for (validation of validationMessages.adrRegion; track validation) {
            <span>
              @if (form1.get('adrRegion').hasError(validation.type) && (form1.get('adrRegion').dirty || form1.get('adrRegion').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>



      <div class="col-lg-12">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="subject" id="subject" type="text" pInputText/>
          <label for="subject">Subject</label>
          @for (validation of validationMessages.subject; track validation) {
            <span>
              @if (form1.get('subject').hasError(validation.type) && (form1.get('subject').dirty || form1.get('subject').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-lg-12">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [filter]="true" filterBy="name" [options]="msgTemplates" formControlName="letterHeadTemplateId" optionLabel="name"
          placeholder="Template" [autoDisplayFirst]="false" optionValue="msgTemplateId" [showClear]="true"></p-dropdown>
          <label for="letterHeadTemplateId">Letter Head Template</label>
        </span>
      </div>
      <div class="col-lg-12">
        <label for="emailHtml">Email Html</label>
        <span class="p-float-label required-field w-100 mb-3">
          <editor formControlName="emailHtml" id="emailHtml" [init]="{
							height: 500,
							base_url: '/tinymce',
							suffix: '.min',
							relative_urls : 0,
              remove_script_host : 0,
							convert_urls: false,
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
          </editor>
          @for (validation of validationMessages.emailHtml; track validation) {
            <span>
              @if (form1.get('emailHtml').hasError(validation.type) && (form1.get('emailHtml').dirty || form1.get('emailHtml').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
        All variables listed at help document: <span><app-help-link [helpName]="'msgCampaign'" [formReadOnly]="true"></app-help-link></span>
      </div>
      <div class="col-lg-12">
        <span class="fp-float-label required-field w-100 mb-3">
          <textarea formControlName="emailText" id="emailText" [rows]="3" pInputTextarea></textarea>
          <label for="emailText">Email Text</label>
          @for (validation of validationMessages.emailText; track validation) {
            <span>
              @if (form1.get('emailText').hasError(validation.type) && (form1.get('emailText').dirty || form1.get('emailText').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <hr>
        <div class="col-lg-4">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown class="w-100" [options]="countries" formControlName="senderCountryCode" optionLabel="name"
            optionValue="dial" placeholder="Country Code"></p-dropdown>
            <label for="senderCountryCode">Sender Country</label>
            @for (validation of validationMessages.senderCountryCode; track validation) {
              <span>
                @if (form1.get('senderCountryCode').hasError(validation.type) && (form1.get('senderCountryCode').dirty || form1.get('senderCountryCode').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-8">
          <span class="p-float-label required-field w-100 mb-3">
            <!-- <p-inputMask formControlName="senderMobileNum" id="senderMobileNum" mask="(999) 999-9999" type="text">
          </p-inputMask> -->
          <input formControlName="senderMobileNum" id="senderMobileNum" type="text" pInputText>
          <label for="senderMobileNum">Sender Mobile Number</label>
          @for (validation of validationMessages.senderMobileNum; track validation) {
            <span>
              @if (form1.get('senderMobileNum').hasError(validation.type) && (form1.get('senderMobileNum').dirty || form1.get('senderMobileNum').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12">
        <span class="p-float-label required-field w-100 mb-3">
          <textarea formControlName="mobileText" id="mobileText" [rows]="8" pInputTextarea style="font-family:monospace;white-space:pre"></textarea>
          <label for="mobileText">Mobile Text (SMS body — use actual line breaks, not \n)</label>
          @for (validation of validationMessages.mobileText; track validation) {
            <span>
              @if (form1.get('mobileText').hasError(validation.type) && (form1.get('mobileText').dirty || form1.get('mobileText').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-lg-12">
        <label for="msgAudience">Message Audiance</label>
        <p-dropdown  [options]="msgTopics" displaySelectedLabel formControlName="msgAudience" [filter]="true" filterBy="name"
          optionLabel="name" optionValue="value" appendTo="body"  optionLabel="name"
        ></p-dropdown>
        @for (validation of validationMessages.msgAudience; track validation) {
          <span>
            @if (form1.get('msgAudience').hasError(validation.type) && (form1.get('msgAudience').dirty || form1.get('msgAudience').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </div>

      <div class="col-lg-12">
        <label for="msgAudience">Ops Notes</label>
        <span class="fp-float-label required-field w-100 mb-3">
          <textarea formControlName="opsNotes" id="opsNotes" [rows]="3" pInputTextarea></textarea>
          <!-- <label for="opsNotes">Ops Notes</label> -->
          @for (validation of validationMessages.opsNotes; track validation) {
            <span>
              @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>
  </div>
  <hr />
  <div class="row m-0">
    <div class="col-lg-12">
      <div class="btn-group">
        <div class="button-group">
          <!--<button pButton *ngIf="msgTemplateId" class="btn-delete p-button-outlined p-button-danger"
        (click)="onFormDelete()">Delete</button>-->
      </div>

      <div class="button-group">
        <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
        @if (!msgTemplateId) {
          <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
        }

        @if (msgTemplateId) {
          <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update</button>
        }
      </div>
    </div>
  </div>
</div>
</div>
